import axios from '../../config/axios';

export async function logout() {
	await axios.get('/api/auth/logout');
}
